// import Routes from 'Routes';
// import { saveOldLocation } from '../../modules/actions';

// export default store => ({
//   path: Routes.ticket.child.changeRefundExplain.key,
//   onEnter(nextState, replace, callback) {
//     callback();
//   },
//   onLeave(prevState) {
//     store.dispatch(saveOldLocation(prevState.location));
//   },
//   getComponent(nextState, cb) {
//     require.ensure(
//       [],
//       require => {
//         const changeRefundExplain = require('./components/changeRefundExplain')
//           .default;
//         cb(null, changeRefundExplain);
//       },
//       'changeRefundExplain'
//     );
//   },
// });

/**
 * 退改计算器结果详情页面
 */
import Routes from 'Routes';
import FeeQueryContainer from './components/FeeQueryContainer';
export default store => ({
  path: Routes.ticket.child.changeRefundExplain.key,
  component: FeeQueryContainer,
  getChildRoutes(partialNextState, cb) {
    require.ensure(
      [],
      require => {
        cb(null, [
          require('./routes/list').default(store),
          require('./routes/detail').default(store),
        ]);
      },
      'feeQueryChilds'
    );
  },
});



// WEBPACK FOOTER //
// ./src/routes/routes/changeRefundExplain/index.js